import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ namespace, scope, elementType }) =>
    present(
      repository
        .getSecondaryCriteriaTemplate(namespace, scope, elementType)
        .then((template) => ({ namespace, scope, elementType, template }))
        .catch(() => Promise.reject({ namespace, scope, elementType })),
    );
}

export type { Interactor };

export { createInteractor };
